import React from 'react';
import { Box, Text } from '@wix/design-system';
import { Confirm, Minus } from '@wix/wix-ui-icons-common';
import { CustomFieldType } from '@wix/bex-core';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { observer } from 'mobx-react-lite';

export interface ExtendedColumnProps {
  value?: any;
  type: CustomFieldType;
}

function _ExtendedColumn(props: ExtendedColumnProps) {
  const { dateFormatters } = useWixPatternsContainer();

  switch (props.type) {
    case 'shortText':
      return (
        <Text size="small" ellipsis maxLines={1}>
          {props.value}
        </Text>
      );
    case 'date':
      return (
        <Text size="small" ellipsis maxLines={1}>
          {props.value && dateFormatters.medium.format(new Date(props.value))}
        </Text>
      );
    case 'dateTime':
      return (
        <Text size="small" ellipsis maxLines={1}>
          {props.value &&
            dateFormatters.mediumTime.format(new Date(props.value))}
        </Text>
      );
    case 'checkbox':
      return (
        <Box
          align="center"
          verticalAlign="middle"
          color={props.value ? 'G10' : 'D10'}
        >
          {props.value ? <Confirm /> : <Minus />}
        </Box>
      );
    case 'longText':
      return (
        <Text size="small" ellipsis maxLines={3}>
          {props.value}
        </Text>
      );
    case 'dropdown':
    case 'integer':
    case 'decimal':
    default:
      return (
        <Text size="small" ellipsis maxLines={1}>
          {props.value}
        </Text>
      );
  }
}

export const ExtendedColumn = observer(_ExtendedColumn);
